// @flow
export default {
  path: '/',
  component: () => import('views/Home.vue'),
  meta: {
    notAuth: true
  },
  children: [
    {
      path: '',
      name: 'Login',
      component: () => import('modules/auth/Login.vue')
    },
    {
      path: '/redirecionar',
      name: 'Redirecionar',
      component: () => import('modules/auth/Redirecionar.vue')
    },
    {
      path: '/consumer',
      name: 'consumerInfor',
      component: () => import('modules/auth/ConsumerInfo.vue')
    },
    {
      path: '/login/:hash',
      name: 'SSO',
      component: () => import('modules/auth/SSO.vue')
    },
    {
      path: '/recover-password',
      name: 'ResetPassword',
      component: () => import('modules/auth/ResetPassword.vue')
    },
    {
      path: 'reset/user/:token',
      name: 'NewPassword',
      component: () => import('modules/auth/NewPassword.vue')
    }

  ]
};
